import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-client-config-list',
  templateUrl: './client-config-list.component.html',
  styleUrls: ['./client-config-list.component.css']
})
export class ClientConfigListComponent implements OnInit {

  clientInfoData: any = [];
  filteredClientInfoData: any = [];
  singleClientInfoData: any = [];

  pageNumber: number = 0;
  totalRecords: number = 0;
  first: number = 0;
  recordsPerPage: number = 10;
  tableSize: number = 10;
  isLoading: any = false;
  id: any;
  recordId: any = "";
  recordName: any = "";
  
  cid: any;
  formSubmit: boolean = false;
  isEdit: boolean = false;

  clientInfoForm: any | FormGroup;
  clientInfoUpdateForm: any | FormGroup;

  actionControls: any = {
    isAdd: false,
    isView: false,
    isDelete: false,
    isModify: false
  };

  searchFilter: any = "";

  industryTypes = [
    { value: 'SERVICE_INDUSTRY', viewValue: 'Service Industry' },
    { value: 'MANUFACTURING_INDUSTRY', viewValue: 'Manufacturing Industry' }
  ];

  constructor(
    private fb: FormBuilder,
    private toastr: ToastrService,
    private generic_service: GenericService
  ) { }

  ngOnInit(): void {
    let href: any = window.location.href;
    let messages = href.split('/');
    let action: any = this.generic_service.checkActionControls(messages[messages.length - 1]);
    this.actionControls = action;

    this.cid = sessionStorage.getItem('cid');
    
    this.initForms();
    this.getAllClientInfo();
  }

  initForms() {
    this.clientInfoForm = this.fb.group({
      phoneNumber: ['', [Validators.required]],
      companyEmailId: ['', [Validators.required]],
      companyName: ['', [Validators.required]],
      industryType: ['', [Validators.required]],
      smsKey: ['', [Validators.required]],
      sendGridKey: ['', [Validators.required]],
      razorpayCurrency: ['', [Validators.required]],
      razorpayKeyId: ['', [Validators.required]],
      msgWhatsappNumber: ['', [Validators.required]],
      msg91AuthKey: ['', [Validators.required]],
      msg91_CREATE_TICKET_FOR_REGISTERED_ONLY: [false],
      msg91_TASK_STATUS_UPDATE_TO_TECHNICIAN: [false],
      updated_MATERIAL_ON_ISSUED: [false],
      update_BALANCES_ON_MATERIAL_ISSUE_APPROVAL: [false],
      material_ISSUE_SEQUENE_AUTOGENERATE: [false],
      customer_AUTO_APPROVED: [false],
      auto_TICKET_CREATION_AT_INVOICE_PAYMENT: [false],
      vendor_AUTO_APPROVED: [false],
      user_CREATION_ON_VENDOR_APPROVED: [false]
    });

    this.clientInfoUpdateForm = this.fb.group({
      phoneNumber: ['', [Validators.required]],
      companyEmailId: ['', [Validators.required]],
      companyName: ['', [Validators.required]],
      industryType: ['', [Validators.required]],
      smsKey: ['', [Validators.required]],
      sendGridKey: ['', [Validators.required]],
      razorpayCurrency: ['', [Validators.required]],
      razorpayKeyId: ['', [Validators.required]],
      msgWhatsappNumber: ['', [Validators.required]],
      msg91AuthKey: ['', [Validators.required]],
      msg91_CREATE_TICKET_FOR_REGISTERED_ONLY: [false],
      msg91_TASK_STATUS_UPDATE_TO_TECHNICIAN: [false],
      updated_MATERIAL_ON_ISSUED: [false],
      update_BALANCES_ON_MATERIAL_ISSUE_APPROVAL: [false],
      material_ISSUE_SEQUENE_AUTOGENERATE: [false],
      customer_AUTO_APPROVED: [false],
      auto_TICKET_CREATION_AT_INVOICE_PAYMENT: [false],
      vendor_AUTO_APPROVED: [false],
      user_CREATION_ON_VENDOR_APPROVED: [false]
    });
  }

  onTableDataChange(event: any) {
    this.pageNumber = event.page + 1;
  }

  getAllClientInfo() {
    this.isLoading = true;
    this.generic_service.getAllClientInfo().subscribe(
      (response: any) => {
        this.clientInfoData = response.response || [];
        this.filteredClientInfoData = [...this.clientInfoData];
        this.totalRecords = this.filteredClientInfoData.length;
        this.isLoading = false;
      },
      (err: any) => {
        console.log(err);
        this.isLoading = false;
      }
    );
  }

  getClientInfoByWildSearch() {
    if (!this.searchFilter) {
      this.filteredClientInfoData = [...this.clientInfoData];
      this.totalRecords = this.filteredClientInfoData.length;
      return;
    }
    const search = this.searchFilter.toLowerCase();
    this.filteredClientInfoData = this.clientInfoData.filter((client: any) => 
      (client.companyName && client.companyName.toLowerCase().includes(search)) ||
      (client.companyEmailId && client.companyEmailId.toLowerCase().includes(search))
    );
    this.totalRecords = this.filteredClientInfoData.length;
  }

  refreshAll() {
    this.pageNumber = 1;
    this.first = 0;
    this.searchFilter = "";
    this.getAllClientInfo();
  }

  getClientInfoById(clientId: any) {
    this.generic_service.getClientInfoByClientId(clientId, this.cid).subscribe(
      (response: any) => {
        this.singleClientInfoData = [response.response];
        this.clientInfoUpdateForm.patchValue({
          phoneNumber: response.response.phoneNumber,
          companyEmailId: response.response.companyEmailId,
          companyName: response.response.companyName,
          industryType: response.response.industryType,
          smsKey: response.response.smsKey,
          sendGridKey: response.response.sendGridKey,
          razorpayCurrency: response.response.razorpayCurrency,
          razorpayKeyId: response.response.razorpayKeyId,
          msgWhatsappNumber: response.response.msgWhatsappNumber,
          msg91AuthKey: response.response.msg91AuthKey,
          msg91_CREATE_TICKET_FOR_REGISTERED_ONLY: response.response.msg91_CREATE_TICKET_FOR_REGISTERED_ONLY,
          msg91_TASK_STATUS_UPDATE_TO_TECHNICIAN: response.response.msg91_TASK_STATUS_UPDATE_TO_TECHNICIAN,
          updated_MATERIAL_ON_ISSUED: response.response.updated_MATERIAL_ON_ISSUED,
          update_BALANCES_ON_MATERIAL_ISSUE_APPROVAL: response.response.update_BALANCES_ON_MATERIAL_ISSUE_APPROVAL,
          material_ISSUE_SEQUENE_AUTOGENERATE: response.response.material_ISSUE_SEQUENE_AUTOGENERATE,
          customer_AUTO_APPROVED: response.response.customer_AUTO_APPROVED,
          auto_TICKET_CREATION_AT_INVOICE_PAYMENT: response.response.auto_TICKET_CREATION_AT_INVOICE_PAYMENT,
          vendor_AUTO_APPROVED: response.response.vendor_AUTO_APPROVED,
          user_CREATION_ON_VENDOR_APPROVED: response.response.user_CREATION_ON_VENDOR_APPROVED
        });
        this.isEdit = true;
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  viewClientInfoById(clientId: any) {
    this.generic_service.getClientInfoByClientId(clientId, this.cid).subscribe(
      (response: any) => {
        this.singleClientInfoData = [response.response];
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  addClientInfo() {
    if (this.formSubmit) {
      return;
    }
    this.formSubmit = true;

    if (!this.clientInfoForm.valid) {
      this.formSubmit = false;
      this.toastr.error("please fill required fields");
      return;
    }

    let body = {
      "version": 0,
      "isActive": true,
      "description": "",
      "phoneNumber": Number(this.clientInfoForm.get('phoneNumber').value),
      "companyEmailId": this.clientInfoForm.get('companyEmailId').value,
      "companyName": this.clientInfoForm.get('companyName').value,
      "smsKey": this.clientInfoForm.get('smsKey').value,
      "sendGridKey": this.clientInfoForm.get('sendGridKey').value,
      "razorpayCurrency": this.clientInfoForm.get('razorpayCurrency').value,
      "industryType": this.clientInfoForm.get('industryType').value,
      "razorpayKeyId": this.clientInfoForm.get('razorpayKeyId').value,
      "msgWhatsappNumber": this.clientInfoForm.get('msgWhatsappNumber').value,
      "msg91AuthKey": this.clientInfoForm.get('msg91AuthKey').value,
      "msg91_CREATE_TICKET_FOR_REGISTERED_ONLY": this.clientInfoForm.get('msg91_CREATE_TICKET_FOR_REGISTERED_ONLY').value,
      "msg91_TASK_STATUS_UPDATE_TO_TECHNICIAN": this.clientInfoForm.get('msg91_TASK_STATUS_UPDATE_TO_TECHNICIAN').value,
      "updated_MATERIAL_ON_ISSUED": this.clientInfoForm.get('updated_MATERIAL_ON_ISSUED').value,
      "update_BALANCES_ON_MATERIAL_ISSUE_APPROVAL": this.clientInfoForm.get('update_BALANCES_ON_MATERIAL_ISSUE_APPROVAL').value,
      "material_ISSUE_SEQUENE_AUTOGENERATE": this.clientInfoForm.get('material_ISSUE_SEQUENE_AUTOGENERATE').value,
      "customer_AUTO_APPROVED": this.clientInfoForm.get('customer_AUTO_APPROVED').value,
      "auto_TICKET_CREATION_AT_INVOICE_PAYMENT": this.clientInfoForm.get('auto_TICKET_CREATION_AT_INVOICE_PAYMENT').value,
      "vendor_AUTO_APPROVED": this.clientInfoForm.get('vendor_AUTO_APPROVED').value,
      "user_CREATION_ON_VENDOR_APPROVED": this.clientInfoForm.get('user_CREATION_ON_VENDOR_APPROVED').value,
      "keyValues": {
        "key": "",
        "value": ""
      },
      "cid": Number(this.cid)
    };

    this.generic_service.addClientInfo(body).subscribe(
      (response: any) => {
        this.formSubmit = false;
        this.clientInfoForm.reset();
        this.cancelModel();
        this.getAllClientInfo();
        this.toastr.success(response.message || "Successfully Added");
      },
      (err: any) => {
        this.formSubmit = false;
        this.toastr.error(err.error?.errors?.[0]?.description || "Error adding client config");
      }
    );
  }

  updateClientInfo() {
    if (this.formSubmit) {
      return;
    }
    this.formSubmit = true;

    if (!this.clientInfoUpdateForm.valid) {
      this.formSubmit = false;
      this.toastr.error("please fill required fields");
      return;
    }

    let body = {
      "version": this.singleClientInfoData[0].version || 0,
      "isActive": true,
      "description": "",
      "id": this.singleClientInfoData[0].id,
      "clientInfoId": this.singleClientInfoData[0].clientInfoId,
      "phoneNumber": Number(this.clientInfoUpdateForm.get('phoneNumber').value),
      "companyEmailId": this.clientInfoUpdateForm.get('companyEmailId').value,
      "companyName": this.clientInfoUpdateForm.get('companyName').value,
      "smsKey": this.clientInfoUpdateForm.get('smsKey').value,
      "sendGridKey": this.clientInfoUpdateForm.get('sendGridKey').value,
      "razorpayCurrency": this.clientInfoUpdateForm.get('razorpayCurrency').value,
      "industryType": this.clientInfoUpdateForm.get('industryType').value,
      "razorpayKeyId": this.clientInfoUpdateForm.get('razorpayKeyId').value,
      "msgWhatsappNumber": this.clientInfoUpdateForm.get('msgWhatsappNumber').value,
      "msg91AuthKey": this.clientInfoUpdateForm.get('msg91AuthKey').value,
      "msg91_CREATE_TICKET_FOR_REGISTERED_ONLY": this.clientInfoUpdateForm.get('msg91_CREATE_TICKET_FOR_REGISTERED_ONLY').value,
      "msg91_TASK_STATUS_UPDATE_TO_TECHNICIAN": this.clientInfoUpdateForm.get('msg91_TASK_STATUS_UPDATE_TO_TECHNICIAN').value,
      "updated_MATERIAL_ON_ISSUED": this.clientInfoUpdateForm.get('updated_MATERIAL_ON_ISSUED').value,
      "update_BALANCES_ON_MATERIAL_ISSUE_APPROVAL": this.clientInfoUpdateForm.get('update_BALANCES_ON_MATERIAL_ISSUE_APPROVAL').value,
      "material_ISSUE_SEQUENE_AUTOGENERATE": this.clientInfoUpdateForm.get('material_ISSUE_SEQUENE_AUTOGENERATE').value,
      "customer_AUTO_APPROVED": this.clientInfoUpdateForm.get('customer_AUTO_APPROVED').value,
      "auto_TICKET_CREATION_AT_INVOICE_PAYMENT": this.clientInfoUpdateForm.get('auto_TICKET_CREATION_AT_INVOICE_PAYMENT').value,
      "vendor_AUTO_APPROVED": this.clientInfoUpdateForm.get('vendor_AUTO_APPROVED').value,
      "user_CREATION_ON_VENDOR_APPROVED": this.clientInfoUpdateForm.get('user_CREATION_ON_VENDOR_APPROVED').value,
      "keyValues": {
        "key": "",
        "value": ""
      },
      "cid": Number(this.cid)
    };

    this.generic_service.updateClientInfo(body).subscribe(
      (response: any) => {
        this.isEdit = false;
        this.formSubmit = false;
        this.clientInfoUpdateForm.reset();
        this.cancelModel();
        this.getAllClientInfo();
        this.toastr.success(response.message || "Successfully Updated");
      },
      (err: any) => {
        this.formSubmit = false;
        this.toastr.error(err.error?.errors?.[0]?.description || "Error updating client config");
      }
    );
  }

  deleteClientInfo() {
    this.generic_service.deleteClientInfo(this.id).subscribe(
      (response: any) => {
        this.toastr.success(response.message || "Successfully Deleted");
        this.getAllClientInfo();
        this.cancelModel();
        this.clearData();
      },
      (error: any) => {
        this.toastr.error(error.error?.errors?.[0]?.description || "Error deleting client config");
      }
    );
  }

  deleteIdSelect(id: any, list: any) {
    this.id = id;
    this.recordId = list.clientInfoId;
    this.recordName = list.companyName;
  }

  clearData() {
    this.recordId = "";
    this.recordName = "";
  }

  closePopUp() {
    this.recordId = "";
    this.recordName = "";
    this.formSubmit = false;
    this.isEdit = false;
    this.clientInfoForm.reset();
    this.clientInfoUpdateForm.reset();
  }

  cancelModel() {
    document.getElementById("closeModalButton")?.click();
    document.getElementById("closeModalButton1")?.click();
    document.getElementById("closeModalButton2")?.click();
    document.getElementById("closeModalButton3")?.click();
  }

}
